import { BackButton, Loader, Toast } from "@egovernments/digit-ui-react-components";
import {
  Table,
  TableContainer,
  Checkbox,
  FormControlLabel,
  Popover,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
  Button,
  TablePagination,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import ClearIcon from "@mui/icons-material/Clear";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import { FaDownload } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import EditNoc from "./EditNoc"; // Import your EditNoc component
import EditIcon from "@mui/icons-material/Edit";
import { Col, Container, Row } from "react-bootstrap";
import InputWrapper from "../../../citizen/AVPForms/layout/inputWrapper";
import ButtonWrapper from "../../../citizen/AVPForms/components/Button";
import { NOCSearch } from "../../../../../../../libraries/src/services/molecules/NOC/Search";

const ViewNOC = () => {
  const tenantId = Digit.ULBService.getStateId() || "up";
    const { t } = useTranslation();
  const ADMIN = Digit.Utils.hrmsAccess();
  const [showError, setShowError] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const SUPERUSER = Digit.Utils.superUserAccess();
  const closeToast = () => {
    setShowToast(null);
  };
  const filterDistrictData = (masterData, authority) => {
    const districtsArray = masterData
      ?.find((item) => item.authorityName === authority)
      ?.Districts?.map((item) => {
        return { name: item?.District, label: item?.District, value: item?.District };
      });
    console.log("districtArray", districtsArray);
    // districtsArray?.length>1?:
    return districtsArray || [];
  };
  const filterTehsilData = (masterData, authority, district) => {
    console.log("filterTehsilDataCalled", masterData, authority);

    const result =
      district && authority
        ? masterData
          ?.find((item) => item.authorityName === authority)
          ?.Districts?.find((item) => item.District === district)
          ?.tehsils?.map((item) => {
            return { name: item.tehsilName, label: item.tehsilName, value: item.tehsilName };
          })
        : null;
    console.log("resultTehsil", result);
    return result || [];
  };
  const filterVillagesData = (masterData, authority, district, tehsil) => {
    console.log("villagesFilteredData", authority, tehsil, district);
    const toTitleCase = (str) =>
      str
        ?.split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
    const result =
      tehsil && district && authority
        ? masterData
          ?.find((item) => item?.authorityName === authority)
          ?.Districts?.find((item) => item?.District === district)
          ?.tehsils?.find((item) => item?.tehsilName === tehsil)
          ?.villages?.map((item) => {
            const formatted = toTitleCase(item);
            return { name: formatted, value: formatted, label: formatted };
          })
        : null;
    return result || [];
  };
  // Fetch department metadata (code, name, message)
  const { data: { NOC: { NocDepartment: mdmsDepartments } = {} } = {}, isLoading: isMdmsLoading } = Digit.Hooks.obps.useMDMS(tenantId, "NOC", [
    "NocDepartment",
  ]);
  const user = Digit.SessionStorage.get("USER_DETAIL") || {};
  const authority = `${user?.location1} Development Authority`;
  console.log("authorityFromNoc", authority, user);
  // Fetch NOC Excel Data
  const { data, isLoading: isDataLoading, error, refetch } = Digit.Hooks.noc.useNOCExcelSearch(tenantId, authority, "", "", [], {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
    // refetchOnWindowFocus: true,
    // refetchOnReconnect: true,
  });
  console.log("logNocSearchDataView", data);

  // Extract array of department objects
  const departmentsList = mdmsDepartments?.[0]?.department || [];
  const headers = departmentsList?.map((dept) => dept.name);
  const baseColumns = [
    { id: "srNo", label: "Sr. No", filterable: false },
    { id: "district", label: "District", filterable: true },
    { id: "tehsil", label: "Tehsil", filterable: true },
    { id: "village", label: "Village", filterable: true },
  ];
  const deptColumns = departmentsList.map((dept) => ({
    id: dept.code,
    label: dept.name,
    filterable: true,
  }));
  const allColumns = [...baseColumns, ...deptColumns];
  console.log("viewNoc", departmentsList, mdmsDepartments, data, headers);
  const handleExcelDownload = () => {
    if (!data || data.length === 0) {
      return;
    }
    const charData = data?.map((item, index) => {
      const row = {
        District: item.RegionInfo?.district,
        Tehsil: item.RegionInfo?.tehsil,
        Village: item.RegionInfo?.village,
      };

      departmentsList.forEach(({ code, name }) => {
        row[name] = item.Departments?.[code] || "-";
      });

      return row;
    });
    return Digit.Download.Excel(charData, "NOC-Data");
  };
  // State for selected columns
  const [selectedColumns, setSelectedColumns] = useState(allColumns.map((col) => col.id));
  const [anchorEl, setAnchorEl] = useState(null);
  const [filters, setFilters] = useState({});
  const [globalSearch, setGlobalSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editMode, setEditMode] = useState(false);
  const [addMode, setAddMode] = useState(false);

  const { data: { BPA: { LandUseVillageMasterData: villagesData } = {} } = {}, isLoading: isVillagesLoading } = Digit.Hooks.obps.useMDMS(
    tenantId,
    "BPA",
    [{ name: "LandUseVillageMasterData", filter: `$[?(@.authorityName=="${authority}")]` }]
  );
  console.log("villagesDataFromNoc", villagesData);

  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      authority: authority ? authority : "",
      authorityDistrict: "",
      authorityTehsil: "",
      authorityVillage: "",
    },
  });

  // watch values so that we can dynamically compute dependents
  const watchDistrict = useWatch({ control, name: "authorityDistrict" });
  const watchTehsil = useWatch({ control, name: "authorityTehsil" });

  const districts = filterDistrictData(villagesData, authority);
  const tehsils = filterTehsilData(villagesData, authority, watchDistrict);
  const villages = filterVillagesData(villagesData, authority, watchDistrict, watchTehsil);

  // whenever district changes clear tehsil/village
  useEffect(() => {
    setValue("authorityTehsil", "");
    setValue("authorityVillage", "");
  }, [watchDistrict]);

  // whenever tehsil changes clear village
  useEffect(() => {
    setValue("authorityVillage", "");
  }, [watchTehsil]);
  // Filtering logic
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const handleGlobalSearch = (value) => {
    setGlobalSearch(value);
    setPage(0);
  };
  const getFilteredData = () => {
    let filteredData = data || [];
    // Global search
    if (globalSearch) {
      filteredData = filteredData.filter((item) => {
        const { RegionInfo, Departments } = item;
        return (
          matchesSearch(RegionInfo?.district, globalSearch) ||
          matchesSearch(RegionInfo?.tehsil, globalSearch) ||
          matchesSearch(RegionInfo?.village, globalSearch) ||
          departmentsList.some((dept) => matchesSearch(Departments?.[dept.code], globalSearch))
        );
      });
    }
    // Column filters
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        filteredData = filteredData.filter((item) => {
          const { RegionInfo, Departments } = item;
          if (key === "district") return matchesSearch(RegionInfo?.district, value);
          if (key === "tehsil") return matchesSearch(RegionInfo?.tehsil, value);
          if (key === "village") return matchesSearch(RegionInfo?.village, value);
          // Department columns
          return matchesSearch(Departments?.[key], value);
        });
      }
    });
    return filteredData;
  };

  const filteredData = getFilteredData();
  const columns = allColumns.filter((col) => selectedColumns.includes(col.id));
  const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  // Popover handlers
  const handleOpenColumnFilter = (event) => setAnchorEl(event.currentTarget);
  const handleCloseColumnFilter = () => setAnchorEl(null);
  const handleColumnToggle = (columnId) => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter((id) => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value,
    });
  };
  const handleClearFilter = (property) => {
    setFilters({
      ...filters,
      [property]: "",
    });
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleAddData = async (payload) => {
    console.log("addDataData", payload);
    const NocDetails = [
      { authority: payload?.authority, district: payload?.authorityDistrict, tehsil: payload?.authorityTehsil, village: payload?.authorityVillage },
    ];
    // const { data } = Digit.Hooks.noc.useNOCExcelUpdate(tenantId, NocDetails);
    try {
      const res = await NOCSearch.updateNocDetail(tenantId, NocDetails);
      console.log("responseFromAddData", res);
      setShowToast({ key: "success", message: res?.Message });
    } catch (e) {
      console.log("response", data);
      setShowToast({ key: "success", message: result?.message });
    }
  };
  // Handler to open edit mode for the first row (or you can add an edit button per row)
  const handleEditClick = (rowData) => {
    setEditMode(true);
  };
  const handleAddClick = (rowData) => {
    setAddMode(true);
  };

  const handleEditCancel = () => {
    setEditMode(false);
  };

  const handleEditSubmit = (updatedData) => {
    // Call your API here with updatedData
    // After successful update:
    setEditMode(false);
    // Optionally, refresh your data here
  };
  useEffect(() => {
    if (refetch) refetch();
  }, []);
  if (isDataLoading || isMdmsLoading) return <Loader />;

  // If in edit mode, show EditNoc
  if (editMode) {
    return (
      <EditNoc
        departmentsList={departmentsList}
        nocSearchData={data}
        isLoading={isMdmsLoading && isDataLoading}
        tenantId={tenantId}
        setEditMode={setEditMode}
        refetch={refetch}
      />
    );
  }

  const renderColumns = allColumns.filter((col) => selectedColumns.includes(col.id));

  if (!editMode) {
    return (
      <React.Fragment>
        <BackButton />
        <div className="emp-table-noc-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <caption className="emp-table-caption">NOC MASTER</caption>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Button
              variant="outlined"
              startIcon={<EditIcon />}
              size="small"
              onClick={() => handleEditClick(filteredData[0])} // Edit first row as example
              sx={{
                height: "27px",
                fontSize: "12px",
                borderColor: "rgb(31, 74, 124)",
                color: "rgb(31, 74, 124)",
              }}
            >
              Edit
            </Button>
            <Button
              variant="outlined"
              startIcon={<EditIcon />}
              size="small"
              onClick={() => handleAddClick(filteredData[0])} // Edit first row as example
              sx={{
                height: "27px",
                fontSize: "12px",
                borderColor: "rgb(31, 74, 124)",
                color: "rgb(31, 74, 124)",
              }}
            >
              Add Data
            </Button>
            <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={handleOpenColumnFilter}
              size="small"
              sx={{
                height: "27px",
                fontSize: "12px",
                borderColor: "rgb(31, 74, 124)",
                color: "rgb(31, 74, 124)",
              }}
            >
              {t("FASTPAS.GLOBAL.FILTERS.TEXT")}({selectedColumns.length}/{allColumns.length})
            </Button>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search here..."
              value={globalSearch}
              onChange={(e) => handleGlobalSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ background: "#2A3F54", color: "#fff", height: "24px", borderRadius: "7px 0px 0px 7px", width: "29px" }} />
                  </InputAdornment>
                ),
                endAdornment: globalSearch && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => handleGlobalSearch("")}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                padding: "0px",
                height: "25px",
                "& .MuiInputBase-root": {
                  height: "27px",
                  padding: "0px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgb(31, 74, 124)",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "0",
                  fontSize: "12px",
                },
              }}
            />
          </div>
        </div>
        <div style={{ overflowX: "auto" }}>
          <TableContainer className="table-container">
            <Popover
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handleCloseColumnFilter}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              className="table-popover"
            >
              <div className="select-column-popover">
                <Typography variant="subtitle2" gutterBottom>
                  Select Columns to Display
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ padding: "0px" }}
                      checked={selectedColumns.length === allColumns.length}
                      indeterminate={selectedColumns.length > 0 && selectedColumns.length < allColumns.length}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedColumns(allColumns.map((col) => col.id));
                        } else {
                          setSelectedColumns([allColumns[0].id]);
                        }
                      }}
                    />
                  }
                  sx={{ margin: "0px", fontWeight: "bold" }}
                  label="Select All"
                />
                {allColumns.map((column) => (
                  <div key={column.id}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{ padding: "0px" }}
                          checked={selectedColumns.includes(column.id)}
                          onChange={() => handleColumnToggle(column.id)}
                          disabled={column.id === "srNo" && selectedColumns.length === 1}
                        />
                      }
                      sx={{ margin: "0px" }}
                      label={column.label}
                    />
                  </div>
                ))}
              </div>
            </Popover>
            <Table stickyHeader className="application-table noc-table">
              <thead>
                <tr>
                  {renderColumns.map((column) => {
                    let stickyClass = "";
                    if (column.id === "srNo") stickyClass = "sticky-col-srno";
                    if (column.id === "district") stickyClass = "sticky-col";
                    if (column.id === "tehsil") stickyClass = "sticky-col-tehsil";
                    if (column.id === "village") stickyClass = "sticky-col-village";
                    return (
                      <th key={column.id} className={stickyClass}>
                        {column.label}
                      </th>
                    );
                  })}
                </tr>
                <tr>
                  {columns.map((column) => {
                    let stickyClass = "";
                    if (column.id === "srNo") stickyClass = "sticky-col-srno";
                    if (column.id === "district") stickyClass = "sticky-col";
                    if (column.id === "tehsil") stickyClass = "sticky-col-tehsil";
                    if (column.id === "village") stickyClass = "sticky-col-village";
                    return (
                      <td key={column.id} className={stickyClass}>
                        {column.filterable && (
                          <TextField
                            variant="standard"
                            size="small"
                            value={filters[column.id] || ""}
                            onChange={(e) => handleFilterChange(column.id, e.target.value)}
                            InputProps={{
                              endAdornment: filters[column.id] && (
                                <InputAdornment position="end">
                                  <IconButton size="small" onClick={() => handleClearFilter(column.id)}>
                                    X
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              "& .MuiInput-input": {
                                color: "black !important",
                                fontSize: "0.75rem",
                              },
                              width: "100%",
                            }}
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {paginatedData.length === 0 ? (
                  <tr>
                    <td colSpan={columns.length} align="center">
                      No records found
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((item, index) => {
                    const { RegionInfo, Departments } = item;
                    return (
                      <tr key={index}>
                        {columns.map((column) => {
                          let stickyClass = "";
                          if (column.id === "srNo") stickyClass = "sticky-col-srno";
                          if (column.id === "district") stickyClass = "sticky-col";
                          if (column.id === "tehsil") stickyClass = "sticky-col-tehsil";
                          if (column.id === "village") stickyClass = "sticky-col-village";
                          if (column.id === "srNo")
                            return (
                              <td key={column.id} className={stickyClass}>
                                {index + 1}
                              </td>
                            );
                          if (column.id === "district")
                            return (
                              <td key={column.id} className={stickyClass}>
                                {RegionInfo?.district || "NA"}
                              </td>
                            );
                          if (column.id === "tehsil")
                            return (
                              <td key={column.id} className={stickyClass}>
                                {RegionInfo?.tehsil || "NA"}
                              </td>
                            );
                          if (column.id === "village")
                            return (
                              <td key={column.id} className={stickyClass}>
                                {RegionInfo?.village || "NA"}
                              </td>
                            );
                          // Department columns
                          return <td key={column.id}>{Departments?.[column.id] || "No"}</td>;
                        })}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </TableContainer>
          {addMode && (
            <section className="groupContainer3">
              <form onSubmit={handleSubmit(handleAddData)}>
                <div className="formContainer">
                  <div className="formHeaderContainer">
                    <h2 className="formHeading">{"Add Data"}</h2>
                  </div>
                  <Container className="formInputContainer" fluid>
                    <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Col>
                        <InputWrapper
                          width={"100%"}
                          control={control}
                          label={"Development Authority"}
                          inputLabel="Select authority"
                          placeholder="Select authority"
                          name="authority"
                          type={"textInput"}
                          mandatory
                          disabled={SUPERUSER ? false : true}
                          validation={{
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          }}
                        />
                      </Col>
                      <Col>
                        <InputWrapper
                          width={"100%"}
                          label={"Select District"}
                          // hasLabel={false}
                          control={control}
                          data={districts || []}
                          placeholder="Select District"
                          name={`authorityDistrict`}
                          type={"searchSelect"}
                          // defaultValue={isDA ? formData?.location1 : formData?.selectedCity}
                          // disabled={}
                          mandatory
                          isRequired
                          validation={{
                            required: { value: true, message: "This field is required" },
                          }}
                        />
                      </Col>
                    </Row>
                    <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Col>
                        <InputWrapper
                          width={"100%"}
                          control={control}
                          label={"Select Tehsil"}
                          data={tehsils || []}
                          inputLabel="Select tehsil"
                          placeholder="Select tehsil"
                          name="authorityTehsil"
                          type={tehsils?.length > 0 ? "searchSelect" : "textInput"}
                          mandatory
                          validation={{
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          }}
                        />
                      </Col>
                      <Col>
                        <InputWrapper
                          width={"100%"}
                          label={"Select Village"}
                          // hasLabel={false}
                          control={control}
                          data={villages || []}
                          placeholder="Select Village"
                          name="authorityVillage"
                          type={villages?.length > 0 ? "searchSelect" : "textInput"}
                          maxLength={30}
                          validation={{
                            required: { value: true, message: "This field is required" },
                          }}
                        />
                      </Col>
                    </Row>
                  </Container>
                </div>
                <div className="footerContainer2">
                  <div className="buttonWrapper">
                    <ButtonWrapper
                      variant="contained"
                      color="success"
                      size="medium"
                      label={"Save"}
                      type="submit"
                      // disabled={loading}
                      sx={{ backgroundColor: "black", marginRight: "4px", marginTop: "20px" }}
                    />
                  </div>
                </div>
              </form>

              {showToast && (
                <Toast error={showToast?.error} warning={showToast?.warning} label={showToast?.message} onClose={closeToast} isDeleteBtn={true} />
              )}
            </section>
          )}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "1rem 0" }}>
            <button
              className="mrlg cursorPointer"
              onClick={handleExcelDownload}
              style={{ display: "flex", justifyContent: "space-around", marginLeft: "3rem" }}
            >
              <FaDownload style={{ fontSize: "18px" }} />
              <i style={{ fontSize: "13px" }}> Download Excel</i>
            </button>
            <TablePagination
              component="div"
              count={filteredData.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
};

export default ViewNOC;
